import PropTypes from 'prop-types';
// biome-ignore lint/correctness/noUnusedImports: existing error
import React from 'react';
import {ResultsCount} from '~/GalleryPB/ResultsCount';
import {Typography} from '~library/atoms/Typography';
import {useMatchQuery} from '~library/hooks/useMatchQuery';
import {largishAndUp} from '~libSass/base/_exports.sass';

export const PageTitle = (props) => {
  const {matches: largeScreens} = useMatchQuery(`(min-width: ${largishAndUp})`);

  return (
    <Typography
      className="gallery__gallery-title"
      variant="header3"
      as="h1"
      data-qa-id="galleryPageTitle"
    >
      {props.text}{' '}
      {largeScreens && props.numTemplates !== null && (
        <ResultsCount numTemplates={props.numTemplates} />
      )}
    </Typography>
  );
};

PageTitle.propTypes = {
  text: PropTypes.string.isRequired,
  numTemplates: PropTypes.number.isRequired,
};
